export default __webpack_public_path__ + "static/media/galileotec.279f3ced.png";